/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import { API_EmailCodeforPortalLogin, API_PortlLogin, API_GetFeatures, API_CreatePaymentSession, API_CreateCustomerSession, API_AppLogin, API_CheckPaymentStatus } from '../utils/apiConstant'

export const EmailCodeforPortalLogin = async (email) => {
    return axios.post(API_EmailCodeforPortalLogin(email), null)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
}

export const PostLogin = async (data) => {
    return axios.post(API_PortlLogin(), data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const GetFeatures = async (device_id) => {
    return axios.get(API_GetFeatures(device_id))
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const CreatePaymentSession = async (data) => {
    return axios.post(API_CreatePaymentSession(), data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const CreateCustomerSession = async (device_id) => {
    return axios.get(API_CreateCustomerSession(device_id))
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const PostAppLogin = async (data) => {
    return axios.post(API_AppLogin(), data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 

export const CheckPaymentStatus = async (data) => {
    return axios.post(API_CheckPaymentStatus(), data)
        .then((res) => {
            return Promise.resolve(res);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
} 